import { CollapsibleReference } from '@/components/CollapsibleReference'
import { InfoTooltip } from '@/components/InfoTooltip'
import { BASELINE_PROMPT_EMPTY_PLACEHOLDER } from '@/features/product-types/labels'

export interface BaselinePromptEditorProps {
  /** The selected extractor's own default prompt text, fetched by the parent
   * row (PRD 00: shared components don't fetch their own data). */
  extractorDefaultPrompt: { content?: string; isLoading: boolean; isError: boolean }
  baselinePrompt: string
  onBaselinePromptChange: (value: string) => void
}

// Extracted from product-types/components/ExtractionSection.tsx, which
// originally hosted this inline - now lives on the dedicated Prompts screen
// instead. Behavior unchanged: a collapsed-by-default "Extractor default"
// reference block, then the Baseline Prompt textarea that overrides it for
// this product only.
export function BaselinePromptEditor({ extractorDefaultPrompt, baselinePrompt, onBaselinePromptChange }: BaselinePromptEditorProps) {
  return (
    <div className="flex flex-col gap-4">
      <CollapsibleReference
        label="Extractor default"
        content={extractorDefaultPrompt.content}
        isLoading={extractorDefaultPrompt.isLoading}
        isError={extractorDefaultPrompt.isError}
        emptyText="Select an extractor to see its default prompt."
      />

      <div className="flex flex-col gap-1">
        <label className="flex items-center gap-1 text-meta font-medium text-text-secondary" htmlFor="baseline-prompt">
          Baseline Prompt
          <InfoTooltip text="Overrides the selected extractor's own default prompt for this product only. Leave blank to use the extractor default shown above." />
        </label>
        <textarea
          id="baseline-prompt"
          rows={6}
          value={baselinePrompt}
          onChange={(event) => onBaselinePromptChange(event.target.value)}
          placeholder={BASELINE_PROMPT_EMPTY_PLACEHOLDER}
          className="rounded-control border border-border bg-surface px-3 py-2 text-body text-text-primary focus:border-accent focus:outline-none disabled:opacity-50"
        />
      </div>
    </div>
  )
}
